import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem("mbg_cart") || "[]"); } catch { return []; }
    });

    useEffect(() => { localStorage.setItem("mbg_cart", JSON.stringify(items)); }, [items]);

    const add = useCallback((product, qty = 1) => {
        setItems(prev => {
            const existing = prev.find(i => i.product_id === product.id);
            if (existing) {
                return prev.map(i => i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
            }
            return [...prev, { product_id: product.id, name: product.name, price: product.price, image: product.image, quantity: qty }];
        });
    }, []);
    const remove = useCallback((pid) => setItems(prev => prev.filter(i => i.product_id !== pid)), []);
    const updateQty = useCallback((pid, qty) => setItems(prev => prev.map(i => i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i)), []);
    const clear = useCallback(() => setItems([]), []);

    const count = items.reduce((a, i) => a + i.quantity, 0);
    const subtotal = items.reduce((a, i) => a + i.price * i.quantity, 0);

    const value = useMemo(
        () => ({ items, add, remove, updateQty, clear, count, subtotal }),
        [items, add, remove, updateQty, clear, count, subtotal]
    );

    return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}
